/**
 * Created by mykurisu on 2017/9/13.
 */
import React from 'react'
import {browserHistory} from 'react-router'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import axios from 'axios'
import qs from 'qs'
import {ActionSheet, Dialog, Toast} from 'react-weui'
import AudioBar from './AudioBar'
import Infobar from './Infobar'
import DiscussArea from './DiscussArea'
import { ClassroomChannelLecturesPopup } from '../../components/classroom'
import { LectureTopLiveroomBar } from '../../components/lecture'
import {WKOperation, WKEvaluation} from '../../components/wk'
import {PushComponent, DeleteComponent,IconFontBox} from '../../components/details'
import {MinaPay} from '../../components/mina'
import VideoArea from './VideoArea'
import {CoverImage, WKToShareCard, WKToIndex, Page, Pay, FollowLiveroom} from '../../components'
import * as liveroomAction from '../../actions/liveroom'
import {renderMoney, isPC, getJsonFromUrl, AddRef, TimeStream} from '../../utils'
import EditLecture from '../../images/lecture/edit-lecture.png'
import PushLecture from '../../images/lecture/push-lecture.png'
import StudentManage from '../../images/lecture/student-manage.png'
import CommentManageImg from '../../images/lecture/comment-manage.png'
import DataAna from '../../images/lecture/data-ana.png'
import tipsIconImg from '../../images/tips-icon.png'
import '../../css/page/RecordedPage.css'

class RecordedPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            canIListen: false,
            pay_show: false,
            push_show: false,
            delete_show: false,
            actions: [
                {
                    label: '取消',
                    onClick: () => this.handleShowClose()
                }
            ],
            lectureType: props.type,
            playing: false,
            DialogButtons: [
                {
                    type: 'default',
                    label: '取消',
                    onClick: () => {
                        this.setState({
                            inputDialog: false
                        })
                    }
                },
                {
                    type: 'primary',
                    label: '确定',
                    onClick: () => {
                        this.handlePasswordCheck();
                    }
                },
            ],
            inputValue: '',
            inputDialog: false,
            passwordMsg: '',
            isShowToast: false,
            toastText: '',
        }
    }

    PageInit() {
        this.props.dispatch({
            type: 'COMPONENT_INIT_COVER_IMAGE',
            payload: {
                height: Math.min(480, document.body.clientWidth) * 0.57,
                image: this.props.lecture.lecture.cover_url,
                url: `/liveroom/${this.props.lecture.liveroom.id}`
            }
        });

        // 初始化邀请卡
        this.props.dispatch({
            type: 'SHARECARD_INIT',
            payload: {
                type: 'lecture',
                role: this.props.lecture.role,
                id: this.props.lecture.lecture.id,
                is_resell: !!this.props.lecture.resell && ((this.props.lecture.resell.money * this.props.lecture.resell.percent / 100) > 1),
                title: this.props.lecture.resell && ((this.props.lecture.resell.money * this.props.lecture.resell.percent / 100) > 1) && '赚' + renderMoney(this.props.lecture.resell.money * this.props.lecture.resell.percent / 100)
            }
        });

        document.title = this.props.lecture.lecture.name;
    }

    componentDidMount() {
        // 校验是否有直播间
        this.props.checkHasLiveroom()

        this.fetchChannelLectures(this.props.lecture.channel)
        document.body.scrollTop = 0;

        this.PageInit();

        if(!this.props.lecture.role.is_manager){
            AddRef()
        }
        

        let data = this.props.lecture;
        let canilisten = data.lecture.lecture_type === 'open_lecture' || data.lecture_access.granted || (data.channel_access && data.channel_access.granted) || data.role.is_liveroom_vip || data.role.is_lecturer || data.role.is_manager;
        if (data.lecture.is_relay) {
            canilisten = false;
            if (data.lecture.lecture_type === 'open_lecture') {
                canilisten = true
            }
            if (data.channel_access && data.channel_access.granted){
                canilisten = true
            }
            if (data.channel_access && !data.channel_access.granted && data.lecture_access.granted){
                canilisten = true
            }
            if (!data.channel_access && data.lecture_access.granted){
                canilisten = true
            }
        }
        if (data.lecture.lecture_type === 'password_lecture' && !data.lecture_access.granted) {
            canilisten = false
        }
        if (data.role.is_manager || data.role.is_lecturer) {
            canilisten = true
        }
        this.setState({
            canIListen: canilisten
        })

        if (canilisten) {
            axios.get(`/api/classroom/${data.lecture.id}/info`, {
                params: {
                    without_body: 1
                }
            })
        }

        if (canilisten && !this.stat_online) {
            let f = () => {
                this.props.dispatch({
                    type: 'STATS_LOG',
                    payload: {
                        action: 'classroom_stat_online',
                        ts: new Date().getTime(),
                        lecture_id: data.lecture.id
                    }
                })
            }
            f()
            this.stat_online = setInterval(f, 60000)
        }

        if (!canilisten && data.lecture.lecture_type === 'pay_channel') {
            window.location.replace(`/channel/${data.channel.id}`)
        }

        // 法务特例
        if (data.channel.id === 281352 && !canilisten) {
            location.replace('/channel2/404.html')
        }

        // 判断评价入口条件
        let isShowEvaEntry = !data.role.is_manager && !data.role.is_lecturer && canilisten && data.lecture.status === 'closed'
        if (!isShowEvaEntry) {
            this.props.dispatch({type: 'WK_HIDE_EVALUATION_ENTRY'})
        }

        if (!data.role.is_manager && !data.lecture_access.granted && !data.role.is_liveroom_vip) {
            this.handleAutoPaying()
        }

        this.backindex_method = () => {
            this.handleEntryAnimation();
        };

        window.addEventListener('scroll', this.backindex_method)
    }

    componentWillUnmount() {
        this.ShareShow && clearTimeout(this.ShareShow);
        this.stat_online && clearInterval(this.stat_online);
        this.AutoPlaying && clearTimeout(this.AutoPlaying);
        this.backindex_method && window.removeEventListener('scroll', this.backindex_method);
    }

    handleShowEnter() {
        if (this.props.lecture.lecture.lecture_type === 'password_lecture') {
            this.setState({
                inputDialog: true
            })
        } else {
            this.setState({
                pay_show: true
            })
        }
    }

    handleShowClose() {
        this.setState({
            pay_show: false
        })
    }

    handlePayLecture() {
        const lectureId = this.props.lecture.lecture.id;
        const {meta} = this.props
        this.handleShowClose();
        this.props.dispatch({
            type: 'PAY_LECTURE',
            payload: {
                params: {
                    product: 'pay_lecture',
                    lecture_id: lectureId,
                    platform: meta.platform,
                    user_sign: meta.user_sign,
                },
                success: (data) => {
                    window.location = `/lecture/${lectureId}/paysuccess${location.search}`;
                }
            }
        })
    }

    handleAutoPaying() {
        const lectureId = this.props.lecture.lecture.id;
        const query = getJsonFromUrl();

        if (query && parseInt(query.autopaying) === 1){
            this.AutoPlaying = setTimeout(() => {
                this.props.dispatch({
                    type: 'PAY_LECTURE',
                    payload: {
                        params: {
                            product: 'pay_lecture',
                            lecture_id: lectureId
                        },
                        success: () => {
                            window.location = `/lecture/${lectureId}/paysuccess${location.search}`;
                        }
                    }
                })
            }, 3000);
        }
    }

    handlePayChannel() {
        const channelId = this.props.lecture.channel.id;
        const {meta} = this.props

        this.handleShowClose();

        if (this.props.lecture.channel.need_money) {
            if (this.props.lecture.channel.is_cost_fix) {
                this.props.dispatch({
                    type: 'PAY_CHANNEL',
                    payload: {
                        params: {
                            product: 'pay_channel',
                            channel_id: channelId,
                            platform: meta.platform,
                            user_sign: meta.user_sign,
                        },
                        success: (data) => {
                            window.location = `/channel/${channelId}/paysuccess${location.search}`;
                        }
                    }
                })
            } else {
                window.location.href = `/channel/${channelId}`
            }
        }
    }

    handleEntryAnimation() {
        const {width} = this.props.sharecard;

        this.ShareShow && clearTimeout(this.ShareShow);

        let self = this;
        this.show_method = function () {
            self.props.dispatch({
                type: 'SHARECARD_SLIDE',
                payload: 87
            })
        };
        if (width !== 87 && !isPC()) {
            this.ShareShow = setTimeout(this.show_method, 3000);
        }

        if (document.body.scrollTop || document.documentElement.scrollTop > 168) {
            if (this.props.sharecard.animated && !isPC()) {
                if (width !== 26) {
                    this.props.dispatch({
                        type: 'SHARECARD_SLIDE',
                        payload: 26
                    })
                }
            } else {
                return true
            }
        }
    }

    handleHidePush() {
        this.setState({
            push_show: false
        })
    }

    handleHideDelete() {
        this.setState({
            delete_show: false
        })
    }

    handleFollowLiveroom() {
        this.props.dispatch({
            type: 'SHOW_FOLLOW_LIVEROOM',
            payload: {
                liveroom: this.props.lecture.liveroom,
                callback: () => {
                    document.querySelector('.focus-btn').style.display = 'none'
                }
            }
        })
    }

    handleShowPassword() {
        this.setState({
            inputDialog: true
        })
    }

    handlePasswordInput(e) {
        this.setState({
            inputValue: e.target.value
        })
    }

    handlePasswordCheck() {
        let form = new FormData();
        form.append('password', this.state.inputValue);
        axios.post(`/api/lecture/${this.props.lecture.lecture.id}/check_password`, form)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        inputDialog: false
                    }, () => {
                        if (window.location.search === '') {
                            window.location.replace(`/lecture/${this.props.lecture.lecture.id}?${Date.now()}`)
                        } else {
                            window.location.replace(`/lecture/${this.props.lecture.lecture.id}${window.location.search}&${Date.now()}`)
                        }
                    });
                } else {
                    this.setState({
                        passwordMsg: res.data.msg
                    });
                }
            })
    }

    fetchChannelLectures (channel) {
        if (!channel) {
            this.props.dispatch({
                type: 'CLASSROOM_SET_CHANNEL_LECTURES',
                payload: []
            })
            return
        }
        axios.get(`/api/channel/${channel.id}/lecture_list`)
            .then(res => {
                if (res.data.code === 0) {
                    this.props.dispatch({
                        type: 'CLASSROOM_SET_CHANNEL_LECTURES',
                        payload: res.data.data.lectures
                    })
                }
            })
    }

    renderMenus() {
        if (this.props.lecture.channel) {
            if (this.props.lecture.channel.promoprice && (this.props.lecture.channel.promoprice.deadline_timestamp > (Date.parse(new Date()) / 1000))) {
                if (this.props.lecture.lecture.lecture_type === 'pay_channel') {
                    return [{
                        label: `购买专栏  ${this.props.lecture.channel.money ? '￥' + renderMoney(this.props.lecture.channel.promoprice.price) : ''}`,
                        onClick: () => this.handlePayChannel()
                    }]
                } else if (this.props.lecture.channel.channel_type !== 'open_channel') {
                    return [{
                        label: `购买专栏  ${this.props.lecture.channel.money ? '￥' + renderMoney(this.props.lecture.channel.promoprice.price) : ''}`,
                        onClick: () => this.handlePayChannel()
                    }, {
                        label: `购买课程  ${this.props.lecture.lecture.money ? '￥' + renderMoney(this.props.lecture.lecture.money) : ''}`,
                        onClick: () => this.handlePayLecture()
                    }]
                } else {
                    return [{
                        label: `购买课程  ${this.props.lecture.lecture.money ? '￥' + renderMoney(this.props.lecture.lecture.money) : ''}`,
                        onClick: () => this.handlePayLecture()
                    }]
                }
            } else {
                if (this.props.lecture.lecture.lecture_type === 'pay_channel') {
                    return [{
                        label: `购买专栏  ${this.props.lecture.channel.money ? '￥' + renderMoney(this.props.lecture.channel.money) : ''}`,
                        onClick: () => this.handlePayChannel()
                    }]
                } else if (this.props.lecture.channel.channel_type !== 'open_channel') {
                    return [{
                        label: `购买专栏  ${this.props.lecture.channel.money ? '￥' + renderMoney(this.props.lecture.channel.money) : ''}`,
                        onClick: () => this.handlePayChannel()
                    }, {
                        label: `购买课程  ${this.props.lecture.lecture.money ? '￥' + renderMoney(this.props.lecture.lecture.money) : ''}`,
                        onClick: () => this.handlePayLecture()
                    }]
                } else {
                    return [{
                        label: `购买课程  ${this.props.lecture.lecture.money ? '￥' + renderMoney(this.props.lecture.lecture.money) : ''}`,
                        onClick: () => this.handlePayLecture()
                    }]
                }
            }
        } else {
            return [{
                label: `购买课程  ${this.props.lecture.lecture.money ? '￥' + renderMoney(this.props.lecture.lecture.money) : ''}`,
                onClick: () => this.handlePayLecture()
            }]
        }
    }

    renderEditList() {
        let data = this.props.lecture;
        return [
            {
                blockContent: {
                    img: DataAna,
                    text: '数据分析',
                    method: () => {
                        location.assign(`/lecture/${data.lecture.id}/analysis`)
                    }
                },
                hasContent: true
            },
            {
                blockContent: {
                    img: EditLecture,
                    text: '课程编辑',
                    method: () => {
                        location.assign(`/lecture/${data.lecture.id}/edit`)
                    }
                },
                hasContent: !data.lecture.is_relay
            },
            {
                blockContent: {
                    img: PushLecture,
                    text: '课程推送',
                    method: () => {
                        this.setState({
                            push_show: true
                        })
                    }
                },
                hasContent: true
            },
            {
                blockContent: {
                    img: StudentManage,
                    text: '学员管理',
                    method: () => {
                        location.assign(`/lecture/${data.lecture.id}/listeners`)
                    }
                },
                hasContent: !data.lecture.is_relay && data.lecture.lecture_type !== 'open_lecture' && data.lecture.lecture_type !== 'pay_channel'
            },
            {
                blockContent: {
                    img: CommentManageImg,
                    text: '评论管理',
                    method: () => {
                        location.assign(`/management/lecture/${data.lecture.id}/comment_manage?liveroom_id=${this.props.lecture.liveroom.id}`)
                    }
                },
                hasContent: true,
            }
        ]
    }

    renderAudioPic() {
        if (this.state.canIListen && this.props.lecture.audio_info.audio_url === '' && this.props.lecture.role.is_manager) {
            return (
                <div className="video-mask" style={{backgroundImage: `url(${this.props.lecture.lecture.cover_url})`}}>
                    <div className="video-mask-bg">
                        <div className="video-mask-btn">
                            浏览器打开讲师管理后台上传音频
                        </div>
                    </div>
                </div>
            )
        }
        if (this.state.canIListen && this.isNoresourceAndNostart()) {
            return (
                <div className="no-resource-no-ready" style={{fontSize: '16px'}}>
                    <p><img src={tipsIconImg} style={{width: "100px"}} alt="tips_icon"/></p>
                    <p style={{opacity: 0}}>开课时间: {TimeStream(this.props.lecture.lecture.start_timestamp, 'MD_HM')}</p>
                    <p>敬请期待</p>
                </div>
            )
        }
        if (this.state.canIListen && this.isNoresourceAndStarting()) {
            return (
                <div className="video-mask" style={{backgroundImage: `url(${this.props.lecture.lecture.cover_url})`}}>
                    <div className="video-mask-bg">
                        <div className="video-mask-btn">
                            {this.props.lecture.role.is_manager ? '浏览器打开讲师管理后台上传音频' : '当前课程尚未上传音频'}
                        </div>
                    </div>
                </div>
            )
        }
        return <CoverImage/>
    }

    isNoresourceAndNostart () {
        return this.props.lecture.audio_info.audio_url === '' && this.props.lecture.lecture.start_timestamp > Date.now() / 1000
    }

    isNoresourceAndStarting () {
        return this.props.lecture.audio_info.audio_url === '' && this.props.lecture.lecture.start_timestamp <= Date.now() / 1000
    }

    onToggleFavourite() {
        const action = this.props.isFavorited ? 'delete' : 'add'
        axios.post(`/api/favourite/${action}`, qs.stringify({
            type: 'lecture',
            lecture_id: this.props.lecture.lecture.id,
        }))
            .then((res) => {
                if (res.data.code === 0) {
                    this.showToast(this.props.isFavorited ? '取消收藏成功' : '收藏成功')
                    this.props.dispatch({
                        type: 'LECTURE_SET_FAVOURITE',
                        payload: !this.props.isFavorited,
                    })
                } else {
                    alert(res.data.msg)
                }
            })
    }

    showToast (text) {
        this.setState({ isShowToast: true, toastText: text })
        setTimeout(() => {
            this.setState({ isShowToast: false })
        }, 1000)
    }
    componentWillReceiveProps (props) {
        // 法务特例
        const {channel} = this.props.lecture
        if (props.wechat.ready && channel.id === 281352) {
            window.wx.hideAllNonBaseMenuItem()
        }
    }
    render() {
        const urlParams = getJsonFromUrl();
        const isMinaApp = urlParams && urlParams.isMinaApp;
        const { isFavorited, role } = this.props

        let btnContent = {
            text: '购买课程',
            method: () => {
                this.handleShowEnter()
            }
        };

        if (this.props.lecture.lecture.lecture_type === 'password_lecture') {
            btnContent = {
                text: '输入密码',
                method: () => {
                    this.handleShowPassword()
                }
            };
        }

        // 小程序支付参数分离
        const {wk_pay_source, mina_type, product, mina_product_id, inviter_id, st, sid, mina_discount_id} = urlParams
        const {lecture_access, channel_access, channel} = this.props.lecture
        // 法务特例
        let isLawSpecial = (channel && channel.id === 281352)
        
        return (
            <Page>
                <div className="recorder-page">
                    {!(lecture_access.granted || (channel_access && channel_access.granted) || role.is_manager) &&
                    <MinaPay idRecordedLecture={true} discountId={mina_discount_id} paySource={wk_pay_source} minaType={mina_type} product={product} id={mina_product_id} inviterId={inviter_id} st={st} sid={sid}/>
                    }

                    <Pay/>

                    <FollowLiveroom/>

                    {!isMinaApp &&
                    <WKToIndex/>
                    }

                    {!this.state.playing && !isMinaApp && (urlParams && !urlParams.lfr) && !isLawSpecial &&
                    <WKToShareCard/>
                    }
                    <LectureTopLiveroomBar type='lecture' subtype='record' />

                    {this.state.lectureType === 'video' && this.props.videoShow &&
                    <VideoArea
                        lecture={this.props.lecture.lecture}
                        role={this.props.lecture.role}
                        canIListen={this.state.canIListen}
                        video_info={this.props.lecture.video_info}
                        poster={this.props.lecture.lecture.cover_url}
                        handleShowEnter={() => this.handleShowEnter()}
                        handlePlay={() => this.setState({playing: true})}
                        handlePause={() => this.setState({playing: false})}
                    />
                    }

                    {this.state.lectureType === 'audio' &&
                    <div className={`video-area ${this.isNoresourceAndNostart() ? 'black' : ''}`}>
                        {this.renderAudioPic()}
                        <AudioBar
                            lecture_id={this.props.lecture.lecture.id}
                            audioInfo={this.props.lecture.audio_info}
                            canIListen={this.state.canIListen}
                            payMethod={() => this.handleShowEnter()}
                            isMinaApp={isMinaApp}
                        />
                    </div>
                    }

                    <Infobar
                        channelAccess={this.props.lecture.channel_access}
                        channel={this.props.lecture.channel}
                        lecture={this.props.lecture.lecture}
                        stats={this.props.lecture.stats}
                        liveroom={this.props.lecture.liveroom}
                        role={this.props.lecture.role}
                        handleFollowLiveroom={() => this.handleFollowLiveroom()}
                        isMinaApp={isMinaApp}
                    />

                    <DiscussArea
                        list={this.state.list}
                        handleLoadMore={() => this.handleLoadMore()}
                        loading={this.state.loading}
                        lectureId={this.props.lecture.lecture.id}
                        liveroomId={this.props.lecture.liveroom.id}
                        account={this.props.account}
                        role={this.props.lecture.role}
                        canIListen={this.state.canIListen}
                        isMinaApp={isMinaApp}
                    />


                    {!this.state.canIListen &&
                    <div>
                        <ActionSheet
                            menus={this.renderMenus()}
                            actions={this.state.actions}
                            show={this.state.pay_show}
                            type="ios"
                            onRequestClose={e => this.setState({pay_show: false})}
                        />
                        <Dialog type="ios" title={'输入密码'} buttons={this.state.DialogButtons}
                                show={this.state.inputDialog}>
                            <div className="recorded-textarea-password">
                                <textarea rows="1" value={this.state.inputValue} onChange={(e) => this.handlePasswordInput(e)}/>
                                <p className="wk-dialog-error">{this.state.passwordMsg === '' ? null : this.state.passwordMsg}</p>
                            </div>
                        </Dialog>
                        <div className="iconFontPart bottom-fixed">
                            <div className={`lecture-bottom-nav-bugsfx`}>
                                <IconFontBox
                                    icon={<img src={isFavorited ? 
                                        'https://static-1253442168.image.myqcloud.com/picture/6031279_85feb7d394082d7c025cf67896ba095e.jpg' :
                                        'https://static-1253442168.image.myqcloud.com/picture/6031279_2cd90631da64bdafe5c17e0025424806.jpg'} alt="收藏icon"/>}
                                    title={isFavorited ? '已收藏' : '收藏'}
                                    onClickHandle={() => this.onToggleFavourite()}
                                />
                                <div className="lecture-bottom-enter-btn weui-flex__item flex_4 weui-flex" onClick={e => btnContent.method()}>
                                    <button className='weui-btn weui-btn_primary enter-btn delete-weuiafter'>{btnContent.text}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                    {this.props.lecture.role.is_manager &&
                    <div>
                        {this.state.push_show &&
                        <PushComponent
                            type={'lecture'}
                            target_id={this.props.lecture.lecture.id}
                            handleHidePush={() => this.handleHidePush()}/>
                        }
                        {this.state.delete_show &&
                        <DeleteComponent
                            type={'lecture'}
                            target_id={this.props.lecture.lecture.id}
                            liveroom_id={this.props.lecture.liveroom.id}
                            handleHideDelete={() => this.handleHideDelete()}/>
                        }

                        {!isMinaApp &&
                        <WKOperation editList={this.renderEditList()}/>
                        }
                    </div>
                    }
                    <Toast icon="success-no-circle" show={this.state.isShowToast}>{this.state.toastText}</Toast>
                    <ClassroomChannelLecturesPopup type='recorded' />
                    {!role.is_manager && !role.is_lecturer && this.state.canIListen && this.props.lecture.lecture.status === 'closed' &&
                    <WKEvaluation account={this.props.account} lecture={this.props.lecture.lecture} isOnlyFirst={false}/>
                    }
                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    wechat: state.wechat,
    account: state.account,
    sharecard: state.sharecard,
    isFavorited: state.lecture.role.is_favorited,
    role: state.lecture.role,
    videoShow: state.lecture.videoShow,
    meta: state.lecture.meta,
}), dispatch => bindActionCreators({...liveroomAction, dispatch}, dispatch))(RecordedPage)


// WEBPACK FOOTER //
// ./src/pages/recordedPage/RecordedPage.js